import { FEED_TABS, TABS_CONFIG } from '@/constants/tabConfig';
import { Tabs, TabsItem } from '@eventbrite/marmalade';
import { useIntl } from 'react-intl';
import styles from './BrowseTabs.module.scss';

export interface BrowseTabsProps {
    onTabChange: (tab: string) => void;
    selectedTab: string;
}

export const BrowseTabs = ({ onTabChange, selectedTab }: BrowseTabsProps) => {
    const intl = useIntl();

    return (
        <Tabs
            aria-label="Browse tabs"
            value={selectedTab}
            onValueChange={(newTab) => selectedTab !== newTab && onTabChange(newTab)}
            className={styles.root}
        >
            {FEED_TABS.map((tab) => {
                const name = TABS_CONFIG[tab].name;
                const displayName = typeof name === 'string' ? name : intl.formatMessage(name);
                return (
                    <TabsItem key={tab} value={tab} className={styles.tab}>
                        {displayName}
                    </TabsItem>
                );
            })}
        </Tabs>
    );
};
